import React, { useEffect, useState } from 'react';
import { Calendar, Info, Logs, MapPin, Paperclip, Rocket, Save, Users2 } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { CreateEventAPI } from '../redux/actions/event-management/CreateEventAction';
import { showErrorToast, showSuccessToast } from '../helpers/SweetAlert';
import { createEventStateReset } from '../redux/slices/event-management/CreateEventSlice';
import { PulseLoader } from 'react-spinners';
import { Link, useNavigate } from 'react-router-dom';
import { GetSportsListApi } from '../redux/actions/event-management/GetSportsListAction';

const CreateNewEvent = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { response, loading, error } = useSelector((state) => state.createEvent);

    const { response: sportsListResponse, error: sportsListError } = useSelector((state) => state.getSportsList)

    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

    const [eventType, setEventType] = useState('');

    const [sport, setSport] = useState('');

    const [title, setTitle] = useState('');

    const [description, setDescription] = useState('');

    const [startDate, setStartDate] = useState('');
    const [startTime, setStartTime] = useState('');

    const [endDate, setEndDate] = useState('');
    const [endTime, setEndTime] = useState('');

    const [location, setLocation] = useState('');

    const [participants, setParticipants] = useState('');

    const [deadline, setDeadline] = useState('');

    const [entry, setEntry] = useState('');

    const [rules, setRules] = useState('');

    const [rewards, setRewards] = useState('');

    const [email, setEmail] = useState('');

    const [phone, setPhone] = useState('');

    const [validationErrors, setValidationErrors] = useState('');

    const [isPlatformChecked, setIsPlatformChecked] = useState(false);

    const [isFeaturedChecked, setIsFeaturedChecked] = useState(false);

    const [isRegisteredChecked, setIsRegisteredChecked] = useState(false);

    const [isEventChecked, setIsEventChecked] = useState(false);

    const [images, setImages] = useState([]);

    const [isDraftDisabled, setIsDraftDisabled] = useState(true);

    const capitalizeFirstLetter = (value) => {
        if (!value) return value;
        return value.charAt(0).toUpperCase() + value.slice(1);
    };

    const getNextDate = (dateValue) => {
        if (!dateValue) return undefined;
        const date = new Date(dateValue);
        if (Number.isNaN(date.getTime())) return undefined;
        date.setDate(date.getDate() + 1);
        return date.toISOString().split('T')[0];
    };

    const handlePlatformToggle = () => {
        setIsPlatformChecked(prev => !prev);
    };


    const handleFeaturedToggle = () => {
        setIsFeaturedChecked(prev => !prev);
    };

    const handleRegisteredToggle = () => {
        setIsRegisteredChecked(prev => !prev)
    }

    const handleEventToggle = () => {
        setIsEventChecked(prev => !prev)
    }

    const resetForm = () => {
        setEventType('');
        setSport('');
        setTitle('');
        setDescription('');
        setStartDate('');
        setStartTime('');
        setEndDate('');
        setEndTime('');
        setLocation('');
        setParticipants('');
        setDeadline('');
        setEntry('');
        setRules('');
        setRewards('');
        setEmail('');
        setPhone('');
        setValidationErrors('');
        setIsPlatformChecked(false);
        setIsFeaturedChecked(false);
        setIsRegisteredChecked(false);
        setIsEventChecked(false);
        setImages([]);
    };

    const validateForm = (eventStatus = 'published') => {
        const newErrors = {};
        const isDraft = eventStatus === 'save_as_draft';

        if (!eventType) {
            newErrors.eventType = 'Event type is required';
        }

        if (!title.trim()) {
            newErrors.title = 'Title is required';
        }

        if (!isDraft && !description.trim()) {
            newErrors.description = 'Description is required';
        }

        if (!isDraft && !sport.trim()) {
            newErrors.sport = 'Sport is required';
        }

        if (!isDraft && !location.trim()) {
            newErrors.location = 'Location is required';
        }

        if (!isDraft && eventType === 'challenge' && !endDate) {
            newErrors.endDate = 'End date is required for challenge';
        }

        if (startDate && endDate && new Date(endDate) <= new Date(startDate)) {
            newErrors.endDate = 'End date must be greater than start date';
        }

        setValidationErrors(newErrors);

        return Object.keys(newErrors).length === 0; // returns true if no errors
    }

    // const handleFileChange = (e) => {
    //     const files = Array.from(e.target.files);
    //     const validImages = [];

    //     // Check if total files exceed the 10 image limit
    //     if (images.length + files.length > 10) {
    //         showErrorToast("Maximum upload limit is 10 images.");
    //         return;
    //     }

    //     for (let file of files) {
    //         if (!allowedTypes.includes(file.type)) {
    //             showErrorToast(`Invalid file type: ${file.name}. Only images are allowed.`);
    //             continue;
    //         }

    //         if (file.size > 2 * 1024 * 1024) {
    //             showErrorToast(`File ${file.name} exceeds 2MB size limit.`);
    //             continue;
    //         }

    //         validImages.push(
    //             file
    //         );
    //     }

    //     updateImages(validImages);
    // };

    // const handleDrop = (e) => {
    //     e.preventDefault();
    //     const files = Array.from(e.dataTransfer.files);
    //     updateImages(files);
    // };

    // const handleDragOver = (e) => {
    //     e.preventDefault();
    // };

    // const updateImages = (files) => {
    //     // const imageFiles = files.filter(file =>
    //     //     ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/svg+xml', 'image/webp'].includes(file.type)
    //     // );

    //     const newPreviews = files.map(file => ({
    //         file,
    //         url: URL.createObjectURL(file),
    //     }));

    //     setImages(prev => [...prev, ...newPreviews].slice(0, 10)); // Max 10 images
    // };

    const handleFileChange = (e) => {
        const file = e.target.files[0]; // only one file

        if (!file) return;

        if (!allowedTypes.includes(file.type)) {
            showErrorToast(`Invalid file type: ${file.name}. Only images are allowed.`);
            return;
        }

        if (file.size > 2 * 1024 * 1024) {
            showErrorToast(`File ${file.name} exceeds 2MB size limit.`);
            return;
        }

        updateImages([file]);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0]; // only one file

        if (!file) return;

        if (!allowedTypes.includes(file.type)) {
            showErrorToast(`Invalid file type: ${file.name}. Only images are allowed.`);
            return;
        }

        if (file.size > 2 * 1024 * 1024) {
            showErrorToast(`File ${file.name} exceeds 2MB size limit.`);
            return;
        }

        updateImages([file]);
    };

    const updateImages = (files) => {
        const newPreviews = files.map(file => ({
            file,
            url: URL.createObjectURL(file),
        }));

        setImages(newPreviews); // replace old images with new one(s)
    };

    const handleRemoveImage = (indexToRemove) => {
        setImages((prev) => prev.filter((_, index) => index !== indexToRemove));
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handlePublishEvent = async (eventStatus = 'published') => {
        if (!validateForm(eventStatus)) return;

        const formData = new FormData();

        // Append each image file
        images.forEach((imgObj, index) => {
            console.log(imgObj, "imgobj")
            formData.append('cover_image', imgObj.file); // Your backend expects req.files
        });

        formData.append('event_type', eventType);
        formData.append('sports_category', sport);
        formData.append('title', title);
        formData.append('description', description);
        formData.append('start_date', startDate);
        formData.append('start_time', startTime);
        formData.append('end_date', endDate);
        formData.append('end_time', endTime);
        formData.append('location', location);
        formData.append('max_participants', participants);
        formData.append('registration_deadline', deadline);
        formData.append('entry_requirement', entry);
        formData.append('prize', rewards);
        formData.append('contact_email', email);
        formData.append('contact_number', phone);
        formData.append('platform_event', isPlatformChecked);
        formData.append('featured_event', isFeaturedChecked);
        formData.append('allow_registration', isRegisteredChecked);
        formData.append('public_event', isEventChecked);
        formData.append('event_status', eventStatus);

        try {
            await dispatch(CreateEventAPI(formData))
        } catch (error) {
            showErrorToast('error in creating event')
        }
    }

    useEffect(() => {
        dispatch(GetSportsListApi());
    }, [dispatch])

    useEffect(() => {
        const isTheseFieldsFilled = !!(
            eventType &&
            title
        );

        setIsDraftDisabled(!isTheseFieldsFilled);
    }, [
        eventType, title
    ]);

    useEffect(() => {
        if (response?.status === true) {
            showSuccessToast(response?.message);
            resetForm();
            dispatch(createEventStateReset());
            navigate('/admin-dashboard/event-and-challenge-management');
        }
    }, [response, dispatch, navigate])

    useEffect(() => {
        if (error) {
            showErrorToast(error?.data);
            dispatch(createEventStateReset());
        }
    }, [error, dispatch])
    return (
        <>
            <div className="page_top_section">
                <div className="page-header">
                    <div className="page-header-left d-flex align-items-center">
                        <div className="page-header-title">
                            <nav class="breadcrumb_nav mb-3">
                                <ul class="breadcrumb mb-0">
                                    <li class="breadcrumb-item"><Link to='/admin-dashboard/event-and-challenge-management'>Event & Challenge Management</Link></li>
                                    <li class="breadcrumb-item text-capitalize">Create New Event</li>
                                </ul>
                            </nav>
                            <h1 className="fs-3 text-black fw-semibold  mb-0 text-capitalize">Create New Event</h1>
                            <p className="text-clr mb-0">Fill in the details below to create a new event or challenge.</p>
                        </div>
                    </div>
                    <div className="page-header-right ms-auto">
                        <div className="page-header-right-items ">
                            <div className="d-flex rtgl-d-none">
                                <button className="page-header-right-close-toggle border-0 bg-transparent" type="button" onClick={() => navigate('/admin-dashboard/event-and-challenge-management')}>
                                    <svg stroke="currentColor" fill="none" strokeWidth={2} viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" className="me-2" height={16} width={16} xmlns="http://www.w3.org/2000/svg">
                                        <line x1={19} y1={12} x2={5} y2={12} />
                                        <polyline points="12 19 5 12 12 5" />
                                    </svg><span>Back</span></button>
                            </div>
                            <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
                                <div className="side-content-blk">
                                    <button className="outline-btn" onClick={() => navigate('/admin-dashboard/event-and-challenge-management')}>
                                        <svg stroke="currentColor" fill="none" strokeWidth={2} viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height={16} width={16} xmlns="http://www.w3.org/2000/svg">
                                            <line x1={19} y1={12} x2={5} y2={12} />
                                            <polyline points="12 19 5 12 12 5" />
                                        </svg>
                                        <span className="btntext">Back to Events</span>
                                    </button>
                                    <button
                                        className="primary-btn"
                                        type="button"
                                        onClick={() => handlePublishEvent('save_as_draft')}
                                        disabled={isDraftDisabled}
                                        style={{
                                            opacity: isDraftDisabled ? 0.5 : 1,
                                            cursor: isDraftDisabled ? 'not-allowed' : 'pointer'
                                        }}
                                    >
                                        <Save />
                                        <span className="btntext">Save as Draft</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="rtgl-d-none d-flex align-items-center">
                        <button className="page-header-right-open-toggle border-0 bg-transparent" type="button">
                            <Logs />
                        </button>
                    </div>

                </div>
            </div>

            <section className="main-section common_section spacer">
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-12">
                            <div className="row gx-4 gy-4">
                                <div className="col-sm-12 col-lg-8 col-xl-8">
                                    <div className='outline_blk'>
                                        <div className='mb-3'>
                                            <h2 className='mb-0 fw-semibold fs-4'>Basic Information</h2>
                                        </div>
                                        <div className='row g-3'>
                                            <div className='col-md-6'>
                                                <div className="form-group">
                                                    <label className="fs-12 fw-semibold mb-1">Event Type *</label>
                                                    <div className="input-field">
                                                        <select className="form-select" value={eventType} onChange={(e) => {
                                                            const value = e.target.value;
                                                            setEventType(value);
                                                            if (validationErrors.eventType) {
                                                                setValidationErrors(prev => ({ ...prev, eventType: false }));
                                                            }
                                                        }}>
                                                            <option value="">Select type</option>
                                                            <option value="event">Event</option>
                                                            <option value="challenge">Challenge</option>
                                                        </select>
                                                    </div>
                                                    {validationErrors.eventType &&
                                                        (
                                                            <span className={`error ${validationErrors.eventType ? '' : 'd-none'}`}>{validationErrors.eventType}</span>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-group">
                                                    <label className="fs-12 fw-semibold mb-1">Sport Category *</label>
                                                    <div className="input-field">
                                                        <select className="form-select" value={sport} onChange={(e) => {
                                                            const value = e.target.value;
                                                            setSport(value);
                                                            if (validationErrors.sport) {
                                                                setValidationErrors(prev => ({ ...prev, sport: false }));
                                                            }
                                                        }}>
                                                            <option value="">All Sport</option>
                                                            {sportsListResponse && sportsListResponse?.data?.length > 0 ? (
                                                                sportsListResponse?.data?.map((sport, index) => (
                                                                    <option key={index} value={sport.id}>
                                                                        {sport.name}
                                                                    </option>
                                                                ))
                                                            ) : sportsListError ? (
                                                                <option disabled>No sports available</option>
                                                            ) : <option disabled>No sports available</option>}
                                                        </select>
                                                    </div>
                                                    {validationErrors.sport &&
                                                        (
                                                            <span className={`error ${validationErrors.sport ? '' : 'd-none'}`}>{validationErrors.sport}</span>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            <div className='col-12'>
                                                <div className="form-group">
                                                    <label className="fs-12 fw-semibold mb-1">Event Title *</label>
                                                    <div className="input-field">
                                                        <input className="form-control" placeholder="Enter event title" type="text" value={title}
                                                            onKeyDown={(e) => {
                                                                // Block spacebar if the field is empty (no characters yet)
                                                                if (e.key === ' ' && e.currentTarget.value.trim() === '') {
                                                                    e.preventDefault(); // 🔥 prevents the space from being typed
                                                                }
                                                            }}
                                                            onChange={(e) => {
                                                                const value = capitalizeFirstLetter(e.target.value);
                                                                setTitle(value);
                                                                if (validationErrors.title) {
                                                                    setValidationErrors(prev => ({ ...prev, title: false }));
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    {validationErrors.title &&
                                                        (
                                                            <span className={`error ${validationErrors.title ? '' : 'd-none'}`}>{validationErrors.title}</span>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            <div className='col-12'>
                                                <div className="form-group">
                                                    <label className="fs-12 fw-semibold mb-1">Description *</label>
                                                    <div className="input-field">
                                                        <textarea className="form-control" placeholder="Provide detailed description of the event" value={description} onKeyDown={(e) => {
                                                            // Block spacebar if the field is empty (no characters yet)
                                                            if (e.key === ' ' && e.currentTarget.value.trim() === '') {
                                                                e.preventDefault(); // 🔥 prevents the space from being typed
                                                            }
                                                        }}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setDescription(value);
                                                                if (validationErrors.description) {
                                                                    setValidationErrors(prev => ({ ...prev, description: false }));
                                                                }
                                                            }}></textarea>
                                                    </div>
                                                    {validationErrors.description &&
                                                        (
                                                            <span className={`error ${validationErrors.description ? '' : 'd-none'}`}>{validationErrors.description}</span>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            <div className='col-12'>
                                                <div className="form-group">
                                                    <label className="fs-12 fw-semibold mb-1">Event Cover Image</label>
                                                    <div className="input-field" onDrop={handleDrop}
                                                        onDragOver={handleDragOver}>
                                                        <input className="form-control d-none" type="file" id="browseFile" onChange={handleFileChange} accept="image/jpeg, image/png, image/jpg, image/webp, image/svg+xml" />
                                                        <label htmlFor='browseFile' className='browse_file_label'>
                                                            <div className='file_preview position-relative'>
                                                                {images.length === 0 && (
                                                                    <span className="attachment-icon">
                                                                        <Paperclip />
                                                                    </span>
                                                                )}
                                                                {images.map((img, index) => (
                                                                    <>
                                                                        <img
                                                                            src={img.url}
                                                                            alt={`preview-${index}`}
                                                                            className='file_preview_img'
                                                                        />
                                                                        <button
                                                                            type='button'
                                                                            onClick={() => handleRemoveImage(index)}
                                                                            style={{
                                                                                position: 'absolute',
                                                                                top: '-6px',
                                                                                right: '-6px',
                                                                                backgroundColor: '#fff',
                                                                                border: '1px solid #ccc',
                                                                                borderRadius: '50%',
                                                                                width: '20px',
                                                                                height: '20px',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                fontSize: '12px',
                                                                                cursor: 'pointer',
                                                                            }}
                                                                        >
                                                                            &times;
                                                                        </button>
                                                                    </>
                                                                ))}
                                                            </div >
                                                            {/* <div className='file_preview'>
                                                                <img src='' className='file_preview_img' />
                                                            </div> */}
                                                            < p > Drop your image here, or browse</p>
                                                            <span>Supports: JPG, PNG, GIF up to 10MB</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='outline_blk'>
                                        <div className='mb-3'>
                                            <h2 className='mb-0 fw-semibold fs-4'>Event Details</h2>
                                        </div>
                                        <div className='row g-3'>
                                            <div className='col-md-6'>
                                                <div className="form-group">
                                                    <label className="fs-12 fw-semibold mb-1">Start Date *</label>
                                                    <div className="input-field">
                                                        <input className="form-control" placeholder="Enter event title" type="date" value={startDate}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setStartDate(value);
                                                                if (endDate && new Date(endDate) <= new Date(value)) {
                                                                    setEndDate('');
                                                                }
                                                            }} />
                                                    </div>
                                                </div>
                                                <div className="form-group mt-3">
                                                    <label className="fs-12 fw-semibold mb-1">End Date</label>
                                                    <div className="input-field">
                                                        <input className="form-control" placeholder="Enter event title" type="date" value={endDate}
                                                            min={getNextDate(startDate)}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setEndDate(value);
                                                                if (validationErrors.endDate) {
                                                                    setValidationErrors(prev => ({ ...prev, endDate: false }));
                                                                }
                                                            }} />
                                                    </div>
                                                    {validationErrors.endDate &&
                                                        (
                                                            <span className={`error ${validationErrors.endDate ? '' : 'd-none'}`}>{validationErrors.endDate}</span>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-group">
                                                    <label className="fs-12 fw-semibold mb-1">Start Time *</label>
                                                    <div className="input-field">
                                                        <input className="form-control" placeholder="Enter event title" type="time" value={startTime}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setStartTime(value);
                                                            }} />
                                                    </div>
                                                </div>
                                                <div className="form-group mt-3">
                                                    <label className="fs-12 fw-semibold mb-1">End Time</label>
                                                    <div className="input-field">
                                                        <input className="form-control" placeholder="Enter event title" type="time" value={endTime}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setEndTime(value);
                                                            }} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-12'>
                                                <div className="form-group">
                                                    <label className="fs-12 fw-semibold mb-1">Location *</label>
                                                    <div className="input-field">
                                                        <input className="form-control" placeholder="Enter venue or location" type="text"
                                                            value={location}
                                                            onKeyDown={(e) => {
                                                                // Block spacebar if the field is empty (no characters yet)
                                                                if (e.key === ' ' && e.currentTarget.value.trim() === '') {
                                                                    e.preventDefault(); // 🔥 prevents the space from being typed
                                                                }
                                                            }}
                                                            onChange={(e) => {
                                                                const value = capitalizeFirstLetter(e.target.value);
                                                                setLocation(value);
                                                                if (validationErrors.location) {
                                                                    setValidationErrors(prev => ({ ...prev, location: false }));
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    {validationErrors.location &&
                                                        (
                                                            <span className={`error ${validationErrors.location ? '' : 'd-none'}`}>{validationErrors.location}</span>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-group">
                                                    <label className="fs-12 fw-semibold mb-1">Maximum Participants</label>
                                                    <div className="input-field">
                                                        <input className="form-control" placeholder="Enter max participants" type="number"
                                                            value={participants}
                                                            onKeyDown={(e) => {
                                                                // Block spacebar if the field is empty (no characters yet)
                                                                if (e.key === ' ' && e.currentTarget.value.trim() === '') {
                                                                    e.preventDefault(); // 🔥 prevents the space from being typed
                                                                }
                                                            }}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setParticipants(value);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-group">
                                                    <label className="fs-12 fw-semibold mb-1">Registration Deadline</label>
                                                    <div className="input-field">
                                                        <input className="form-control" placeholder="Enter event title" type="date" value={deadline}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setDeadline(value);
                                                            }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='outline_blk'>
                                        <div className='mb-3'>
                                            <h2 className='mb-0 fw-semibold fs-4'>Additional Settings</h2>
                                        </div>
                                        <div className='row g-3'>
                                            <div className='col-12'>
                                                <div className="form-group">
                                                    <label className="fs-12 fw-semibold mb-1">Entry Requirements</label>
                                                    <div className="input-field">
                                                        <textarea className="form-control" placeholder="Any specific requirements for participants" value={entry}
                                                            onKeyDown={(e) => {
                                                                // Block spacebar if the field is empty (no characters yet)
                                                                if (e.key === ' ' && e.currentTarget.value.trim() === '') {
                                                                    e.preventDefault(); // 🔥 prevents the space from being typed
                                                                }
                                                            }}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setEntry(value);
                                                            }}
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-12'>
                                                <div className="form-group">
                                                    <label className="fs-12 fw-semibold mb-1">Rules & Guidelines</label>
                                                    <div className="input-field">
                                                        <textarea className="form-control" placeholder="Event rules and guidelines" value={rules}
                                                            onKeyDown={(e) => {
                                                                // Block spacebar if the field is empty (no characters yet)
                                                                if (e.key === ' ' && e.currentTarget.value.trim() === '') {
                                                                    e.preventDefault(); // 🔥 prevents the space from being typed
                                                                }
                                                            }}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setRules(value);
                                                            }}
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-12'>
                                                <div className="form-group">
                                                    <label className="fs-12 fw-semibold mb-1">Prizes & Rewards</label>
                                                    <div className="input-field">
                                                        <textarea className="form-control" placeholder="Describe prizes and rewards (if any)" value={rewards}
                                                            onKeyDown={(e) => {
                                                                // Block spacebar if the field is empty (no characters yet)
                                                                if (e.key === ' ' && e.currentTarget.value.trim() === '') {
                                                                    e.preventDefault(); // 🔥 prevents the space from being typed
                                                                }
                                                            }}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setRewards(value);
                                                            }}
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-group">
                                                    <label className="fs-12 fw-semibold mb-1">Contact Email</label>
                                                    <div className="input-field">
                                                        <input className="form-control" placeholder="Contact email for inquiries" type="text" value={email} onKeyDown={(e) => {
                                                            // Block spacebar if the field is empty (no characters yet)
                                                            if (e.key === ' ' && e.currentTarget.value.trim() === '') {
                                                                e.preventDefault(); // 🔥 prevents the space from being typed
                                                            }
                                                        }}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setEmail(value);
                                                            }} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-group">
                                                    <label className="fs-12 fw-semibold mb-1">Contact Phone</label>
                                                    <div className="input-field">
                                                        <input className="form-control" placeholder="Contact phone number" type="text" value={phone}
                                                            onKeyDown={(e) => {
                                                                // Block spacebar if the field is empty (no characters yet)
                                                                if (e.key === ' ' && e.currentTarget.value.trim() === '') {
                                                                    e.preventDefault(); // 🔥 prevents the space from being typed
                                                                }
                                                            }}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setPhone(value);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 col-lg-4 col-xl-4">
                                    <div className='outline_blk'>
                                        <div className='mb-3'>
                                            <h2 className='mb-0 fw-semibold fs-5'>Event Settings</h2>
                                        </div>
                                        <div className='event_setting_toggle'>
                                            <div className='event_setting_item hstack justify-content-between align-items-center gap-3'>
                                                <div className='event_setting_info'>
                                                    <h3>Platform Event</h3>
                                                    <p>Mark as official platform event</p>
                                                </div>
                                                <div className='toggle-box'>
                                                    <input class="d-none" type="checkbox" id="checkbox1" checked={isPlatformChecked}
                                                        onChange={handlePlatformToggle} />
                                                    <label htmlFor="checkbox1"></label>
                                                </div>
                                            </div>
                                            <div className='event_setting_item hstack justify-content-between align-items-center gap-3'>
                                                <div className='event_setting_info'>
                                                    <h3>Featured Event</h3>
                                                    <p>Show in featured section</p>
                                                </div>
                                                <div className='toggle-box'>
                                                    <input class="d-none" type="checkbox" id="checkbox2" checked={isFeaturedChecked}
                                                        onChange={handleFeaturedToggle} />
                                                    <label htmlFor="checkbox2"></label>
                                                </div>
                                            </div>
                                            <div className='event_setting_item hstack justify-content-between align-items-center gap-3'>
                                                <div className='event_setting_info'>
                                                    <h3>Allow Registration</h3>
                                                    <p>Users can register for event</p>
                                                </div>
                                                <div className='toggle-box'>
                                                    <input class="d-none" type="checkbox" id="checkbox3" checked={isRegisteredChecked}
                                                        onChange={handleRegisteredToggle} />
                                                    <label htmlFor="checkbox3"></label>
                                                </div>
                                            </div>
                                            <div className='event_setting_item hstack justify-content-between align-items-center gap-3'>
                                                <div className='event_setting_info'>
                                                    <h3>Public Event</h3>
                                                    <p>Visible to all users</p>
                                                </div>
                                                <div className='toggle-box'>
                                                    <input class="d-none" type="checkbox" id="checkbox4" checked={isEventChecked}
                                                        onChange={handleEventToggle} />
                                                    <label htmlFor="checkbox4"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='outline_blk'>
                                        <div className='mb-3'>
                                            <h2 className='mb-0 fw-semibold fs-5'>Preview</h2>
                                        </div>
                                        <div className='inner_outline_blk'>
                                            <div className='event_preview_cover'>
                                                {images.map((img, index) => (
                                                    <img src={img.url} key={index} className='file_preview_img' alt="Event preview" />
                                                ))}
                                                {/* <span>Event Cover Preview</span> */}
                                            </div>
                                            <h3>Event Title</h3>
                                            <p className='ev_pre_info'><Calendar /> {(startDate || startTime) ? `${startDate} ${startTime}` : 'Date & Time'}</p>
                                            <p className='ev_pre_info'><MapPin /> {location ? location : 'Location'}</p>
                                            <p className='ev_pre_info'><Users2 /> {participants ? participants : 'Participants'}</p>
                                            <p className='text-truncate fs-14 mt-2 mb-0'>{description ? description : 'Event description will appear here...'}</p>
                                            <div className='mt-3'>
                                                <button className="primary-btn w-100" disabled>
                                                    <span className="btntext" style={{ cursor: 'not-allowed' }}>Register Now</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='outline_blk'>
                                        <div className='mb-3'>
                                            <h2 className='mb-0 fw-semibold fs-5'>Publish Event</h2>
                                        </div>
                                        <div className='vstack gap-3'>
                                            <button className="primary-btn w-100" onClick={() => handlePublishEvent('published')}>
                                                <Rocket />
                                                <span className="btntext">{loading ? <PulseLoader color="#ffffff" /> : 'Publish Event'}</span>
                                            </button>
                                            {/* <button className="outline-btn w-100">
                                                <Eye />
                                                <span className="btntext">Preview Event</span>
                                            </button> */}
                                            {/* <button className="outline-btn w-100">
                                                <Save />
                                                <span className="btntext">Save as Draft</span>
                                            </button> */}
                                        </div>
                                        <p className='infomative_note'><Info /> Events will be reviewed before going live. You'll receive a notification once approved.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default CreateNewEvent
